/* eslint-disable no-nested-ternary */
import { useCallback, useEffect, useRef, useState } from 'react';

import moment from 'moment';
import { useHistory, useParams } from 'react-router-dom';
import { Theme, useTheme } from '@material-ui/core';

import { ModalHandles } from '../../newComponents/Modal';

import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';

import api from '../../services/api';
import OrdersService, { IOrderToEdit } from '../../services/OrdersService';

import { calcOrderPrice } from '../../utils/calcOrderPrice';

import { IFormaPagamentoEmpresa } from '../../interfaces/IPaymentMethod';
import { IDiscountCoupon } from '../../interfaces/IDiscountCoupon';
import { ICustomer } from '../../interfaces/ICustomer';
import { ICartItem } from '../../interfaces/ICartItem';
import { IColor } from '../../interfaces/IColor';
import { ISize } from '../../interfaces/ISize';
import { IDeliveryAddress } from '../../interfaces/IDeliveryAddress';
import APIError from '../../errors/APIError';
import { useHeader } from '../../hooks/header';

interface IUseEditOrder {
  cart: ICartItem[];
  cartIsLoading: boolean;
  modalCancelRef: React.RefObject<ModalHandles>;
  modalCreateUserRef: React.RefObject<ModalHandles>;
  selectedDeliveryType: 'TAKEOUT' | 'INDOOR' | 'DELIVERY';
  selectedClient: ICustomer | null;
  selectedAddress: any;
  selectedCoupon: any;
  seletedProductId: number | null;
  seletedEditCartItemId: number | null;
  setSeletedEditCartItemId: React.Dispatch<React.SetStateAction<number | null>>;
  addItemToCart: (payload: any) => void;
  editItemToCart: (itemId: number, payload: any) => void;
  removeItemToCart: (id: number) => void;
  setDeliveryType: React.Dispatch<
    React.SetStateAction<'TAKEOUT' | 'INDOOR' | 'DELIVERY'>
  >;
  setSelectedCoupon: React.Dispatch<any>;
  setSeletedProductId: React.Dispatch<React.SetStateAction<number | null>>;
  handleFinalizeOrder: () => Promise<void>;

  selectdePaymentMethod: {
    paymentMethod: IFormaPagamentoEmpresa;
    changeMoney: number | null;
  } | null;
  setSelectedPaymentMethod: React.Dispatch<
    React.SetStateAction<{
      paymentMethod: IFormaPagamentoEmpresa;
      changeMoney: number | null;
    } | null>
  >;
  setScheduledDelivery: React.Dispatch<React.SetStateAction<Date | null>>;
  scheduledDelivery: Date | null;
  colorsAndSizesAll: {
    colors: IColor[] | null;
    sizes: ISize[] | null;
  };

  deliveryFee: any;
  history: any;
  finalPrice: number;
  step: number;
  orderId: any;
  discountOnTheOutside: number | null;
  setDiscountOnTheOutside: React.Dispatch<React.SetStateAction<number | null>>;
  nextStep: () => void;
  prevStep: () => void;
  theme: Theme;
  order: IOrderToEdit | null;
  observation: string;
  setObservation: React.Dispatch<React.SetStateAction<string>>;

  asideIsClosed: boolean;
  setAsideisClosed: React.Dispatch<React.SetStateAction<boolean>>;

  asideIsOpen: boolean;
  setAsideIsOpen: React.Dispatch<React.SetStateAction<boolean>>;

  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function useEditOrder(): IUseEditOrder {
  const { orderId } = useParams<any>();
  const history = useHistory();
  const { addToast } = useToast();
  const { caixa, user } = useAuth();
  const theme = useTheme();

  const { asideIsOpen, setAsideIsOpen } = useHeader();

  const modalCancelRef = useRef<ModalHandles>(null);
  const modalCreateUserRef = useRef<ModalHandles>(null);

  const [finalPrice, setFinalPrice] = useState(0);
  const [selectedClient, setSelectedClient] = useState<ICustomer | null>(null);
  const [cart, setCart] = useState<ICartItem[]>([]);

  const [selectedDeliveryType, setDeliveryType] = useState<
    'TAKEOUT' | 'INDOOR' | 'DELIVERY'
  >('TAKEOUT');
  const [
    selectedAddress,
    setSelectedAddress,
  ] = useState<IDeliveryAddress | null>(null);
  const [selectedCoupon, setSelectedCoupon] = useState<IDiscountCoupon | null>(
    null,
  );
  const [seletedProductId, setSeletedProductId] = useState<number | null>(null);
  const [seletedEditCartItemId, setSeletedEditCartItemId] = useState<
    number | null
  >(null);
  const [selectdePaymentMethod, setSelectedPaymentMethod] = useState<{
    paymentMethod: IFormaPagamentoEmpresa;
    changeMoney: number | null;
  } | null>(null);

  const [order, setOrder] = useState<IOrderToEdit | null>(null);

  const [scheduledDelivery, setScheduledDelivery] = useState<Date | null>(null);
  const [deliveryFee, setDeliveryFee] = useState<any | null>(null);
  const [colorsAndSizesAll, setColorsAndSizesAll] = useState<{
    colors: IColor[] | null;
    sizes: ISize[] | null;
  }>({
    colors: null,
    sizes: null,
  });
  const [step, setStep] = useState(0);
  const [discountOnTheOutside, setDiscountOnTheOutside] = useState<
    number | null
  >(null);

  const [cartIsLoading, setCartIsLoading] = useState(true);

  const [observation, setObservation] = useState('');

  const [asideIsClosed, setAsideisClosed] = useState(true);

  const [isLoading, setIsLoading] = useState(false);

  const prevStep = useCallback(
    () => setStep((oldState) => (oldState > 0 ? oldState - 1 : oldState)),
    [],
  );

  const nextStep = (): void => {
    if (cart.length === 0) {
      addToast({
        type: 'info',
        title: 'Adicione pelo menos 1 produto no carrinho.',
      });
      return;
    }

    if (!selectedDeliveryType) {
      addToast({
        type: 'info',
        title: 'Selecione o meio de entrega.',
      });
      return;
    }

    if (selectedDeliveryType === 'DELIVERY' && !selectedAddress) {
      addToast({
        type: 'info',
        title:
          'Selecione um endereço para a entrega delivery ou troque o tipo da entrega.',
      });
      return;
    }

    setStep((oldState) => (oldState < 1 ? oldState + 1 : oldState));
  };

  const addItemToCart = (
    payload: Omit<ICartItem, 'id'>,
    orderItemId?: number,
  ): void => {
    setCart((oldState) => {
      const id =
        orderItemId ??
        oldState.reduce((acc, item) => {
          return item.id <= acc ? item.id - 1 : acc;
        }, -1);
      return [...oldState, { id, ...payload } as ICartItem];
    });
  };

  const editItemToCart = (
    itemId: number,
    payload: Omit<ICartItem, 'id'>,
  ): void => {
    setCart((oldState) => {
      const filteredItems = oldState.filter((item: any) => item.id !== itemId);

      filteredItems.push({ id: itemId, ...payload });

      return filteredItems;
    });
  };

  const removeItemToCart = useCallback(
    (id: number): void => {
      const foundCartItem = cart.find((item) => item.id === id);

      if (!foundCartItem) return;

      if (id > 0) {
        foundCartItem.deletedAt = moment(new Date())
          .utcOffset(0, true)
          .format();

        const newList = cart.filter((item) => item.id !== id);
        newList.push(foundCartItem);
        setCart(newList);

        return;
      }

      setCart((oldState) => oldState.filter((item) => item.id !== id));
    },
    [cart],
  );

  const handleFinalizeOrder = async (): Promise<void> => {
    if (cart.filter((item) => !item.deletedAt).length === 0) {
      addToast({
        type: 'info',
        title: 'Adicione pelo menos 1 produto no carrinho.',
      });
      return;
    }

    if (!selectedDeliveryType) {
      addToast({
        type: 'info',
        title: 'Selecione o meio de entrega.',
      });
      return;
    }

    if (selectedDeliveryType === 'DELIVERY' && !selectedAddress) {
      addToast({
        type: 'info',
        title:
          'Selecione um endereço para a entrega delivery ou troque o tipo da entrega.',
      });
      return;
    }

    if (selectedDeliveryType === 'DELIVERY' && !deliveryFee) {
      addToast({
        type: 'error',
        title: 'Nenhuma taxa de entrega encontrada para este endereço.',
      });
      return;
    }

    if (!selectdePaymentMethod) {
      addToast({
        type: 'info',
        title: 'Selecione uma forma de pagamento.',
      });
      return;
    }

    if (finalPrice < 0) {
      addToast({
        type: 'error',
        title: 'O valor final não pode ser abaixo de zero.',
      });
      return;
    }

    if (
      selectdePaymentMethod.paymentMethod.forma_pagamento.descricao ===
        'Dinheiro' &&
      selectdePaymentMethod.changeMoney !== 0 &&
      finalPrice > (selectdePaymentMethod.changeMoney || 0)
    ) {
      addToast({
        type: 'info',
        title:
          'O valor em dinheiro precisa ser igual ou superior ao valor total ou igual a zero.',
      });
      return;
    }

    try {
      setIsLoading(true);

      const response = await OrdersService.editOrder({
        id: orderId,
        cashierId: caixa.id,
        companyId: user.empresa_id,
        companyPaymentMethodId: selectdePaymentMethod.paymentMethod.id,
        extraDiscount: discountOnTheOutside ?? 0,
        items: cart.map((item) => {
          return {
            id: item.id > 0 ? item.id : undefined,
            productId: item.compositeProduct.product.id,
            observation: item.observation || undefined,
            quantity: item.quantity,
            sizeId:
              item?.childOrderItems[0]?.produto?.grids[0].sizeId ?? undefined,
            gridId: item.gridProduct?.id ?? undefined,
            complements: item.compositeProduct.complements.map((comp) => {
              return {
                id: comp.complement.id,
                quantity: comp.quantity,
              };
            }),
            childOrderItems: item.childOrderItems.map((grid: any) => {
              return {
                productId: grid.produto.id,
                quantity: grid.quantidade,
              };
            }),
            deletedAt: item.deletedAt ?? undefined,
          };
        }),
        orderType: selectedDeliveryType,
        changeMoney: selectdePaymentMethod.changeMoney
          ? selectdePaymentMethod.changeMoney - finalPrice
          : undefined,
        customerId: selectedClient?.id ?? undefined,
        deliveryAddressId:
          selectedDeliveryType === 'DELIVERY' ? selectedAddress?.id : undefined,
        discountCouponId: selectedCoupon?.id ?? undefined,
        observation:
          selectedDeliveryType === 'INDOOR'
            ? `Consumo no local - ${observation}`
            : observation || undefined,
        scheduledAt: scheduledDelivery
          ? moment(scheduledDelivery).utcOffset(0, true).format()
          : undefined,
      });

      addToast({
        type: 'success',
        title: 'Pedido alterado.',
      });

      setIsLoading(false);

      history.push(`/monitor_pedidos?orderId=${response.id}&status=edited`);
    } catch (err) {
      console.log(err);

      setIsLoading(false);

      if (err instanceof APIError) {
        addToast({
          title: err.message,
          type: 'error',
        });
        return;
      }
      addToast({
        type: 'error',
        title: 'Erro ao editar pedido. Tente novamente.',
      });
    }
  };

  useEffect(() => {
    if (
      order !== null &&
      selectdePaymentMethod === null &&
      cart.length > 0 &&
      order.items.length === cart.length
    ) {
      const itemsValue = cart
        .filter((item) => item.deletedAt === undefined)
        .map((item) => calcOrderPrice(item))
        .reduce((acc: number, cur: number) => +acc + +cur, 0);

      setSelectedPaymentMethod({
        paymentMethod: (order.companyPaymentMethod as unknown) as IFormaPagamentoEmpresa,
        changeMoney: Number(order.changeMoney)
          ? +order.changeMoney +
            itemsValue -
            +order.totalDiscount +
            +order.deliveryFee
          : null,
      });
    }
  }, [cart, cart.length, order, selectdePaymentMethod]);

  useEffect(() => {
    if (user.empresa_id && caixa.id) {
      const loadOrder = async (): Promise<void> => {
        try {
          const response = await OrdersService.showOrderToEdit(
            user.empresa_id,
            caixa.id,
            orderId,
          );
          setOrder(response);

          setSelectedClient(response.customer as ICustomer);
          setDeliveryType(response.orderType);

          response.scheduledDeliveryAt &&
            setScheduledDelivery(new Date(response.scheduledDeliveryAt));

          response.deliveryAddressId &&
            setSelectedAddress({
              id: response.deliveryAddressId,
              address: response.address,
            } as IDeliveryAddress);

          setObservation(
            response.note
              ? response.note.startsWith('Consumo no local - ')
                ? response.note.split('Consumo no local - ')[1]
                : ''
              : '',
          );

          if (response.deliveryAddressId) {
            setDeliveryFee({ id: 0, value: +response.deliveryFee });
          }

          if (response.othersDiscountsValue) {
            setDiscountOnTheOutside(+response.othersDiscountsValue);
          }

          response.items.forEach((orderItem: any) => {
            if (orderItem.product.controlGrid === 0) {
              addItemToCart(
                {
                  compositeProduct: {
                    product: {
                      ...orderItem.product,
                      name: orderItem.productName,
                    },
                    complements: orderItem.childOrderItems.map(
                      (orderItems: any) => ({
                        complement: {
                          ...orderItems.complementItem,
                          name: orderItems.productName,
                        },
                        quantity: +orderItems.quantity,
                      }),
                    ),
                  },
                  childOrderItems: [],
                  quantity: +orderItem.quantity,
                  observation: orderItem.observation || '',
                },
                orderItem.id,
              );
            } else if (orderItem.product.controlGrid === 1) {
              addItemToCart(
                {
                  compositeProduct: {
                    product: {
                      ...orderItem.product,
                      name: orderItem.productName,
                      price: { ...orderItem.productGrid.price },
                      discount: { ...orderItem.productGrid.discount },
                      complements: [],
                    },
                    complements: orderItem.childOrderItems.map(
                      (orderItems: any) => ({
                        complement: {
                          ...orderItems.complementItem,
                          name: orderItems.productName,
                        },
                        quantity: +orderItems.quantity,
                      }),
                    ),
                  },
                  childOrderItems: [],
                  gridProduct: {
                    ...orderItem.productGrid,
                    name: orderItem.productGridName,
                    colorId: orderItem.colorId,
                    sizeId: orderItem.sizeId,
                  },
                  quantity: +orderItem.quantity,
                  observation: orderItem.observation || '',
                },
                orderItem.id,
              );
            } else {
              addItemToCart(
                {
                  compositeProduct: {
                    product: {
                      ...orderItem.product,
                      name: orderItem.productName,
                    },
                    complements: orderItem.childOrderItems
                      .filter((orderItems: any) => !orderItems.productGrid)
                      .map((orderItems: any) => ({
                        complement: {
                          ...orderItems.complementItem,
                          name: orderItems.productName,
                        },
                        quantity: +orderItems.quantity,
                      })),
                  },
                  childOrderItems: orderItem.childOrderItems
                    .filter((orderItems: any) => orderItems.productGrid)
                    .map((orderItems: any) => ({
                      id: orderItems.id,
                      produto: {
                        id: orderItems.product.id,
                        grids: [
                          {
                            sizeId: orderItem.sizeId,
                            ...orderItems.productGrid,
                          },
                        ],
                        name: orderItems.productName,
                      },
                      quantidade: +orderItems.quantity,
                    })),
                  size: orderItem.productGridName,
                  quantity: +orderItem.quantity,
                  observation: orderItem.observation || '',
                },
                orderItem.id,
              );
            }
          });

          setCartIsLoading(false);
        } catch (error) {
          console.log(error);
          addToast({
            type: 'error',
            title: 'Erro ao buscar dados do pedido.',
          });
        }
      };
      loadOrder();
    }
  }, [addToast, caixa.id, orderId, user.empresa_id]);

  useEffect(() => {
    const fetchDataColors = async (): Promise<void> => {
      const { data } = await api.get(`companies/${user.empresa_id}/colors`);
      setColorsAndSizesAll((oldState) => ({ ...oldState, colors: data }));
    };

    const fetchDataSizes = async (): Promise<void> => {
      const { data } = await api.get(`companies/${user.empresa_id}/sizes/all`);
      setColorsAndSizesAll((oldState) => ({ ...oldState, sizes: data }));
    };

    fetchDataColors();
    fetchDataSizes();
  }, [user.empresa_id]);

  useEffect(() => {
    let result = 0;

    const itemsValue = cart
      .filter((item) => item.deletedAt === undefined)
      .map((item) => calcOrderPrice(item))
      .reduce((acc: number, cur: number) => +acc + +cur, 0);

    const deliveryValue = Number(deliveryFee?.value || 0);

    let couponValue = 0;

    if (selectedCoupon) {
      if (selectedCoupon.type === 1) {
        couponValue = +selectedCoupon.value;
      } else {
        couponValue =
          cart
            .filter((item) => item.deletedAt === undefined)
            .map((item) => calcOrderPrice(item))
            .reduce((acc: number, cur: number) => +acc + +cur, 0) *
          (+selectedCoupon.value / 100);
      }
    }

    result =
      itemsValue - couponValue + deliveryValue - (discountOnTheOutside ?? 0);

    setFinalPrice(result);
  }, [cart, deliveryFee, discountOnTheOutside, selectedCoupon]);

  useEffect(() => {
    if (order && order.discountCouponId) {
      const loadCoupon = async (): Promise<void> => {
        try {
          const { data } = await api.get(
            `cupom-desconto/${order.discountCouponId}`,
          );

          const formatedCoupon: IDiscountCoupon | null = data
            ? {
                active: data.ativo,
                code: data.chave,
                companyId: data.empresa_id,
                createdAt: data.data_inclusao,
                description: data.descricao,
                id: data.id,
                limitPerCoupon: data.limite_geral,
                limitPerUser: data.limite_cliente,
                type: data.tipo_desconto,
                value: data.valor_desconto,
                daysAvailable: data.dias,
                deletedAt: data.data_exclusao,
                expiredAt: data.data_termino,
                inactivedAt: data.data_inativacao,
                minimumSpend: data.compra_minima,
                updatedAt: data.data_alteracao,
              }
            : null;

          setSelectedCoupon(formatedCoupon);
        } catch (error) {
          console.log(error);
        }
      };
      loadCoupon();
    }
  }, [order]);

  useEffect(() => {
    if (!selectedClient && selectedCoupon) {
      setSelectedCoupon(null);
    }
  }, [selectedClient, selectedCoupon]);

  return {
    orderId,
    selectedDeliveryType,
    setDeliveryType,
    selectedClient,
    selectedAddress,
    selectedCoupon,
    setSelectedCoupon,
    seletedProductId,
    setSeletedProductId,
    cart,
    cartIsLoading,
    addItemToCart,
    editItemToCart,
    removeItemToCart,
    handleFinalizeOrder,
    selectdePaymentMethod,
    setSelectedPaymentMethod,
    scheduledDelivery,
    setScheduledDelivery,
    seletedEditCartItemId,
    setSeletedEditCartItemId,
    colorsAndSizesAll,
    deliveryFee,
    discountOnTheOutside,
    finalPrice,
    history,
    modalCancelRef,
    modalCreateUserRef,
    nextStep,
    prevStep,
    setDiscountOnTheOutside,
    step,
    theme,
    order,
    observation,
    setObservation,

    asideIsClosed,
    asideIsOpen,
    setAsideisClosed,
    setAsideIsOpen,

    isLoading,
    setIsLoading,
  };
}
